module.exports = __webpack_public_path__ + "img/trigger.9ad4351e.svg";